import React from 'react'

import { SvgIcon } from '@mui/material'

const path = `
  M11.45 5.55C11.64 5.74 11.95 5.76 12.17 5.59C13.3 4.69 14.65 4.2 16 4.2C17.35 4.2 18.7 4.69 19.84 5.59C20.05 5.76
  20.36 5.74 20.56 5.55L20.6 5.5C20.82 5.28 20.81 4.91 20.57 4.7C19.24 3.57 17.62 3 16 3C14.38 3 12.76 3.57 11.43
  4.7C11.19 4.91 11.17 5.27 11.4 5.5L11.45 5.55ZM13.15 6.31C12.9 6.51 12.89 6.89 13.11 7.11L13.15 7.15C13.35 7.35 13.65
  7.35 13.87 7.19C14.5 6.71 15.25 6.5 16 6.5C16.75 6.5 17.5 6.71 18.13 7.18C18.35 7.35 18.66 7.34 18.85 7.14L18.89
  7.1C19.12 6.87 19.1 6.5 18.85 6.3C18.02 5.66 17.01 5.3 16 5.3C14.99 5.3 13.98 5.66 13.15 6.31ZM19 13H17V10C17 9.45
  16.55 9 16 9C15.45 9 15 9.45 15 10V13H5C3.9 13 3 13.9 3 15V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V15C21 13.9
  20.1 13 19 13ZM8 18H6V16H8V18ZM11.5 18H9.5V16H11.5V18ZM15 18H13V16H15V18Z
`

export default props => (
  <SvgIcon {...props}>
    <g id="aroya-gateway">
      <path d={path} />
    </g>
  </SvgIcon>
)
